import { useMutation } from '@tanstack/react-query'

import { resendEmailConfirmation } from '@flecto/api/shared'

type MutationPayload = {
  auth0_id: string
}

export function useMutationResendEmailVerification() {
  return useMutation({
    mutationFn: async ({ auth0_id }: MutationPayload) => {
      await resendEmailConfirmation(auth0_id)
    },
  })
}
